import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {Http, RequestOptions, XHRBackend} from '@angular/http';
import {LoaderService} from '@catapp/modules/base-app/services';
import {NotificationsService} from '@catcore/services';
import {
  PendingInterceptorService,
  PendingInterceptorServiceFactoryProvider,
} from '@catloader/loader-service/services/pending-interceptor.service';
import {httpServiceFactory} from '@catloader/loader-service/utils/http-service-factory.factory';
import {LoaderComponent} from './loader-service/components/loader/loader.component';

const publicComponents = [
  LoaderComponent,
];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const PendingInterceptorServiceExistingProvider = {
  provide: HTTP_INTERCEPTORS,
  useExisting: PendingInterceptorService,
  multi: true,
};

const providers = [
  LoaderService,
  {
    provide: Http,
    useFactory: httpServiceFactory,
    deps: [XHRBackend, RequestOptions, NotificationsService, LoaderService],
  },
  PendingInterceptorServiceExistingProvider,
  PendingInterceptorServiceFactoryProvider,
  PendingInterceptorService,
];

/**
 * The module provides all components and services to use a global loading requests indicator
 */
@NgModule({
  imports,
  declarations,
  providers,
  exports: exportings,
})
export class NgxHttpLoaderModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/ngx-http-loader.module.ts